"use client";

import Image from "next/image";

export type PartnerGroup = {
  id: string;
  title: string;
  logos: string[];
  maxHeightClass: string;
};

// const PARTNER_GROUPS: PartnerGroup[] = [
//   {
//     id: "developer",
//     title: "ĐƠN VỊ PHÁT TRIỂN & VẬN HÀNH",
//     logos: ["/logos/zengroup_logo.png"],
//     maxHeightClass: "max-h-[100px]",
//   },
//   {
//     id: "distributor",
//     title: "ĐƠN VỊ PHÂN PHỐI CHIẾN LƯỢC",
//     logos: [
//       "/logos/west_land.png",
//       "/logos/phuc_thinh.png",
//       "/logos/nt_group.png",
//       "/logos/ben_thanh_invest.png",
//       "/logos/dat_phu_sa.png",
//     ],
//     maxHeightClass: "max-h-[100px]",
//   },
//   {
//     id: "bank-strategic",
//     title: "NGÂN HÀNG CHIẾN LƯỢC",
//     logos: ["/logos/mb.png", "/logos/tp.png"],
//     maxHeightClass: "max-h-[70px]",
//   },
//   {
//     id: "bank-partner",
//     title: "NGÂN HÀNG ĐỒNG HÀNH",
//     logos: [
//       "/logos/viet_com.png",
//       "/logos/viet_tin.png",
//       "/logos/vib.png",
//       "/logos/saigon-bank.png",
//       "/logos/mbv.png",
//     ],
//     maxHeightClass: "max-h-[70px]",
//   },
// ];

export default function SectionPartners({
  PARTNER_GROUPS,
}: {
  PARTNER_GROUPS?: PartnerGroup[];
}) {
  if (!PARTNER_GROUPS) return null;
  return (
    <section className="bg-white py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-16 space-y-8">
        {PARTNER_GROUPS.map((group) => (
          <div key={group.id} className="space-y-1">
            {/* TITLE */}
            <h3
              className="
                text-center
                text-primary
                text-sm
                font-semibold
                tracking-[0.3em]
                uppercase
              "
            >
              {group.title}
            </h3>

            {/* LOGO ROW */}
            <div
              className="
                flex
                flex-wrap
                justify-center
                items-center
                gap-x-16
                gap-y-10
              "
            >
              {group.logos.map((logo, idx) => (
                <Image
                  key={idx}
                  src={logo}
                  alt=""
                  width={240}
                  height={120}
                  className={`
                  max-h-[70px]
                    w-auto
                    object-contain
                    opacity-80
                    hover:opacity-100
                    transition
                  `}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
